import { render, staticRenderFns } from "./HubFacebookPostsModal.vue?vue&type=template&id=0243db0e&scoped=true&"
import script from "./HubFacebookPostsModal.vue?vue&type=script&lang=js&"
export * from "./HubFacebookPostsModal.vue?vue&type=script&lang=js&"
import style0 from "./HubFacebookPostsModal.vue?vue&type=style&index=0&id=0243db0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0243db0e",
  null
  
)

export default component.exports